import React, {useContext, useEffect} from 'react';
import {ScrubContainerContext} from "../../context/ScrubContainerContext";
import {HELP_CENTER_STRINGS, SCRUB_CONTAINER_STRINGS} from "../../../../constants/Strings";
import {FormattedMessage} from "react-intl";
import {AppNavigationContext} from "../../../app-navigation/context/AppNavigationContext";
import {getHelpOptions, getSelectContainerRoutingPath} from "../../../utils/Util";
import {STOW_AREA_OPERATION} from "../../../../constants/StowAreaOperation";
import {ScanWithCodeView} from "@amzn/dolphin-uiweb-framework";
import ScanView from "../../../scan-view/ScanView";
import Column from "@amzn/meridian/column";
import {validateContainerBeforeScrubAction} from "../../action/ScrubContainerAction";
import {NotificationContext} from "../../../notification/context/NotificationContext";
import QrCode from "../../../../images/ic_qr_code.png";
import {PlayerContext} from "../../../player/context/PlayerContext";
import {ScanTypes} from "../../../player/PlayerConstant";
import {ApplicationActions} from "../../../player/action/ApplicationActions";

const ScanContainerView = (props) => {
    const {scrubContainerViewModel, scrubContainerDispatch} = useContext(ScrubContainerContext)
    const {navActions: {setHelpOption, closeHelpOption}} = useContext(AppNavigationContext)
    const {notificationActions: {clearNotification}} = useContext(NotificationContext);
    const {statePlayer, dispatchPlayer} = useContext(PlayerContext)

    const onScan = (input) => {
        clearNotification();
        scrubContainerViewModel.containerScannableId = input;
        statePlayer.scanType = ScanTypes.SCRUB_CONTAINER;
        validateContainerBeforeScrubAction(scrubContainerDispatch, scrubContainerViewModel.containerScannableId);
    }


    useEffect(() => {
        const callbacks = [
            () => {
                dispatchPlayer({type: ApplicationActions.HELP_OPTION_SELECTED, data: {operation: HELP_CENTER_STRINGS.CLOSE_CONTAINER_HELP}});
                props.history.push(getSelectContainerRoutingPath(STOW_AREA_OPERATION.CLOSE_CONTAINER))
            },
            closeHelpOption
        ]
        setHelpOption(true, getHelpOptions(callbacks,
            <FormattedMessage id={HELP_CENTER_STRINGS.STOW_PROBLEMS_HELP}/>,
            <FormattedMessage id={HELP_CENTER_STRINGS.CLOSE_CONTAINER}/>));
        return () => setHelpOption(false, {});
    }, []);

    const init = {
        primaryTitle: {
            title: <FormattedMessage id={SCRUB_CONTAINER_STRINGS.scrub_container_scan_title}/>,
            type: "Bold"
        },
        secondaryTitle: {
            title: <FormattedMessage id={SCRUB_CONTAINER_STRINGS.scrub_container_scan_subtitle}/>
        },
        image: QrCode,
    }

    return (
        <Column spacingInset="medium" alignmentHorizontal="center">
            {<ScanWithCodeView {...init} /> }
            <ScanView onScan={onScan}/>
        </Column>
    )
}

export default ScanContainerView

